import {FormErrorBox} from "common/FormErrorBox"
import {useForm} from "react-hook-form"
import {User} from "dto/User"
import {useNavigate, useParams} from "react-router-dom"
import {useFindUserById, useUpdateUser} from "hooks/query/user-query"
import {useEffect} from "react"
import dayjs from "dayjs"
import {NotificationType, showNotification} from "common/Notification"

export function UpdateUserForm() {
    const {register, handleSubmit, formState: {errors}, setFocus, watch, setValue} = useForm<User>()
    const {id} = useParams()
    const navigate = useNavigate()
    const {data: user} = useFindUserById(id)
    const updateUserMutate = useUpdateUser()

    useEffect(() => {
        if (!user) return
        setValue("id", user.id)
        setValue("username", user.username)
        setValue("email", user.email)
        setValue("firstName", user.firstName)
        setValue("lastName", user.lastName)
        setValue("enabled", user.enabled)

    }, [setValue, user])
    console.log("user", user)
    const submit = (value: User) => {
        const userParams = Object.assign({}, user, value)
        console.log("submit value: ", userParams)
        updateUserMutate.mutate(userParams, {
            onSuccess: () => showNotification("사용자 정보를 수정하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("사용자 정보 수정이 실패하였습니다")
        })
    }
    const createdAt = dayjs(user?.createdTimestamp).format("YYYY/MM/DD HH:mm") || "-"
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="mt40 ml20">
                <div className="gray-label is-size-85">ID</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="입력"
                           {...register("id")}
                           disabled/>
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">등록일</div>
                <div className="">
                    <div className="input is-gray"
                         style={{paddingTop: 11, height: 42, backgroundColor: "rgb(246, 245,245)"}}>
                        <span>{createdAt}</span>
                    </div>
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">User ID</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="입력" disabled
                           {...register("username")}
                    />
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">Email</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="email"
                           {...register("email",)}
                    />
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">이름(First Name)</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="입력"
                           {...register("firstName", {required: "이름이 필요합니다"})}
                    />
                    <FormErrorBox error={errors.firstName}/>
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">성(Last Name)</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="입력"
                           {...register("lastName")}
                    />
                    <FormErrorBox error={errors.lastName}/>
                </div>
            </div>
            <div className="mt20 ml20">
                <div className="gray-label is-size-85">사용여부</div>
                <div className="gray-boxline">
                    <div className="btn-check check-on">
                        <div className="btn-select"></div>
                    </div>
                </div>
            </div>

            <div className="hr-line-dashed mt30"></div>

            <div className="mt30 ml20">
                <button className="button is-purple2">확인</button>
                <div className="button is-clickable ml-2" onClick={() => navigate("/user/list")}>목록으로</div>
            </div>
        </form>
    )
}